module.exports = __webpack_public_path__ + "assets/images/585a02834e3e86da8e84516e0ca00e87.png";